import NightShelterOutlinedIcon from '@mui/icons-material/NightShelterOutlined';

import TechnicalTypesManagerPage from 'src/pages/Dashboard/System/TechnicalTypes/TechnicalTypesManagerPage';
import systemOptionsStore from 'src/stores/systemOptionsStore';

const Accommodations = () => {
  const {
    accommodations: items,
    deleteAccommodation: deleteItem,
    deleteAllAccommodations: deleteAllItems,
    fetchAccommodations: fetchItems,
    isLoading,
    saveAccommodation: saveItem,
  } = systemOptionsStore(systemOptionsState => systemOptionsState);

  return (
    <TechnicalTypesManagerPage
      entityType="accommodations"
      storeSelectors={{ items, isLoading, fetchItems, saveItem, deleteItem, deleteAllItems }}
      i18nKeys={{
        prefix: 'system.accommodations',
        emptyPrefix: 'empty.accommodations',
        errorsPrefix: 'system.accommodations.errors',
      }}
      emptyIcon={<NightShelterOutlinedIcon />}
      editorModalId="accommodation-editor"
      defaultIcon="tent"
    />
  );
};

export default Accommodations;
